import { Grid } from "@material-ui/core";
import React from "react";
import ButtonLoginWithItsme from "components/buttons/primary-buttons/ButtonLoginWithItsme";
import "./login-multiple-type.scss";
import i18next from "assets/i18n/i18n";
import LoginForm from "../login-form/login-form";

type LoginMultipleTypeProps = {
    spFull: string;
    authType: string;
    acs: string;
};

const LoginMultipleType = ({ spFull, authType, acs }: LoginMultipleTypeProps): React.ReactElement => {
    const Or = () => {
        return (
            <>
                <Grid item xs={4}>
                    <div className="border-line" />
                </Grid>
                <Grid item xs={1} className="border-line-text">
                    {i18next.t("LoginPage.MultipleTypes.Or")}
                </Grid>
                <Grid item xs={4}>
                    <div className="border-line" />
                    <div className="div-spacer" />
                </Grid>
            </>
        );
    };

    return (
        <Grid container>
            <Grid item lg={2} />
            <Grid item container xs className="login-multiple-type-rectangle" justifyContent="center">
                <Grid item container className="login-multiple-type-btn" xs={10} justifyContent="center">
                    <ButtonLoginWithItsme spFull={spFull} acs={acs} />
                </Grid>
                <Grid item container className="border-line-container" xs={10} justifyContent="center">
                    <Or />
                </Grid>
                <Grid item container xs={10} justifyContent="center">
                    <LoginForm spFull={spFull} authType={authType} acs={acs} />
                </Grid>
            </Grid>
        </Grid>
    );
};

export default LoginMultipleType;
